import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Share from './share';
import raf from 'raf';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getSlideCommentCount } from '../../../../services/api';
import { transform } from '@ifeng-fe/container_content/common/client/utils/utils';

class Header extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        txtShow: PropTypes.bool,
    };

    state = {
        allowComment: false,
        count: 0,
        translateY: 0,
    };

    async componentDidMount() {
        const {
            docData: { commentUrl },
        } = this.props.content;

        const { join_count, allow_comment } = await getSlideCommentCount(commentUrl);

        this.setState({
            allowComment: allow_comment !== -1,
            count: join_count,
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.txtShow !== prevProps.txtShow) {
            if (this.props.txtShow) {
                this.downSlide();
            } else {
                this.upSlide();
            }
        }
    }

    upSlide = () => {
        let { translateY } = this.state;

        const step = () => {
            translateY += 10;

            this.setState({
                translateY,
            });

            if (translateY > 90) {
                raf.cancel(step);

                this.setState({
                    translateY: 90,
                });
            } else {
                raf(step);
            }
        };

        raf(step);
    };

    downSlide = () => {
        let { translateY } = this.state;

        const step = () => {
            translateY -= 10;

            this.setState({
                translateY,
            });

            if (translateY < 0) {
                raf.cancel(step);

                this.setState({
                    translateY: 0,
                });
            } else {
                raf(step);
            }
        };

        raf(step);
    };

    setLocation = translateY => {
        return 'WebKitCSSMatrix' in window ? `translate3d(0, -${translateY}px, 0)` : `translate(0, -${translateY}px)`;
    };

    /**
     * 渲染网页布局
     */
    render() {
        const { allowComment, count, translateY } = this.state;
        const {
            content: {
                channel,
                downloads,
                docData,
                docData: { base62Id },
                interact,
            },
        } = this.props;

        const channelTitle = channel.title ? `${channel.title}频道` : '大风号';
        const url = `//gentie.ifeng.com/c/comment/${base62Id}`;

        return (
            <div className={styles.header} style={{ ...transform(this.setLocation(translateY)) }}>
                <a href="//i.ifeng.com" className={styles.logo}>
                    手机凤凰网
                </a>
                <h2 className={styles.channelName}>
                    <a href={channel.url}>{channelTitle}</a>
                </h2>
                <div className={styles.comment_box}>
                    {allowComment ? (
                        <a href={url}>
                            <div className={styles.pic} />
                            <div className={styles.count}>{count}</div>
                        </a>
                    ) : null}
                    {!interact?.isCloseShare && <Share docData={docData} content={downloads} />}
                </div>
            </div>
        );
    }
}

export default errorBoundary(Header);
